<template>
    <v-row>
        <v-col>
            <v-card class="pa-4">
                <v-card-title>{{ entity.title }}</v-card-title>
                <v-card-text>
                    <CollectionTabLinks />
                    <v-row class="pl-3 pb-3" />
                    <v-form>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="entity.title"
                                    outlined
                                    label="Название"
                                    hide-details
                                    @input="updateTitle"
                                />
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="entity.host"
                                    outlined
                                    label="Привязанный домен"
                                    :prefix="'https://'"
                                    hide-details
                                />
                            </v-col>
                        </v-row> -->
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="entity.code"
                                    outlined
                                    label="Код коллекции"
                                    :prefix="siteLinkPreset"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-img width="300px" v-if="entity.picture" :src="imageSrc(entity.picture)" class="mb-4" />
                                <v-file-input
                                    label="Картинка"
                                    outlined
                                    prepend-icon="mdi-image"
                                    hide-details
                                    @change="setPicture"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    v-model="entity.description"
                                    outlined
                                    label="Заголовок"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    v-model="entity.subdescription"
                                    outlined
                                    label="Описание"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-switch
                                    v-model="entity.enabled"
                                    label="Активен"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pa-4 d-flex justify-space-between">
                    <div>
                        <v-btn
                            color="primary"
                            class="mr-3"
                            @click="save"
                        >Сохранить</v-btn>
                        <v-btn
                            color="light"
                            class="mr-3"
                            @click="goBack"
                        >Отмена</v-btn>
                    </div>
                    <v-btn
                        v-if="isAdmin"
                        color="error"
                        @click="deleteModal = true"
                    >Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>

        <v-dialog
            v-model="deleteModal"
            width="800px"
        >
            <v-card>
                <v-card-title class="error">
                    Подтверждение
                </v-card-title>

                <v-card-text>
                    Вы действительно хотите удалить коллекцию? Это действие нельзя будет отменить.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                        color="error"
                        @click="remove"
                    >Удалить</v-btn>
                    <v-spacer />
                    <v-btn
                        color="light"
                        @click="deleteModal = false"
                    >Отмена</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import axios from 'axios';
    import store from '../../store';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { mapState } from 'vuex';
    import { yandexMap, ymapMarker } from 'vue-yandex-maps';
    import CollectionTabLinks from '../../components/collections/CollectionTabLinks';

    import { imageSrc, translit } from '../../helpers';

    export default {
        name: 'CollectionEdit',

        components: {
            CollectionTabLinks,
            yandexMap, 
            ymapMarker
        },

        data() {
            return {
                imageSrc,
                entity: {
                    site_type_id: null,
                    code: '',
                    host: '',
                    title: '',
                    picture: '',
                    description: '',
                    enabled: true,
                    position: 0
                },
                startPages: [
                    { code: 'site', title: 'Сайт' },
                    { code: 'delivery', title: 'Доставка' },
                    { code: 'menu', title: 'Электронное меню' }
                ],
                permitions: {
                    delivery: false,
                    full_menu: false,
                },
                mapZoom: 12,
                deleteModal: false,
            };
        },

        computed: {
            ...mapState('auth', ['user']),
            ...mapState('collections', {
                oldCollection: state => state.entity
            }),
            ...mapState('siteTypes', {
                siteTypes: state => state.entities
            }),
            siteLinkPreset() {
                return `${ process.env.VUE_APP_FRONT_URL }/collection/`
            },
            isAdmin() {
                return this.user.admin;
            },
        },

        async mounted() {
            const id = this.$route.params.id;
            await store.dispatch('siteTypes/fetch');
            if(id) {
                await store.dispatch('collections/get', {id});
                this.entity = {
                    ...this.entity,
                    ...this.oldCollection
                };
                this.permitions = {
                    ...this.permitions,
                    ...this.oldCollection.permitions
                };
                this.entity.coordinates = this.entity.coordinates || [];
            }
        },

        methods: {
            updateTitle(title) {
                this.entity.code = translit(title);
            },
            async setPicture(file) {
                this.entity.picture = await store.dispatch('files/upload', { file });
            },
            async setMenuFile(file) {
                this.entity.menu_file = await store.dispatch('files/upload', { file });
            },
            async removeMenuFile(file) {
                this.entity.menu_file = null;
            },
            async setLegalInformation(file) {
                this.entity.legal_information = await store.dispatch('files/upload', { file });
            },
            async removeLegalInformation(file) {
                this.entity.legal_information = null;
            },
            async save() {
                try {
                    this.entity.permitions = this.permitions;
                    store.commit('collections/SET_ENTITY', this.entity);
                    await store.dispatch('collections/save');
                    this.goBack();
                } catch (error) {
                    alert('Ошибка сохранения');
                }
            },
            async remove() {
                const { id } = this.$route.params;
                try {
                    await store.dispatch('collections/delete', { id });
                    this.$router.push('/collections');
                } catch (error) {
                    alert('Ошибка удаления');
                }
            },
            goBack() {
                const { id } = this.$route.params;
                if(id) {
                    this.$router.push(`/collections/${ id }/detail`);
                } else {
                    this.$router.push('/collections');
                }
            },
        },
    };
</script>

<style lang="scss">
    .entity_edit {
        &__map {
            width: 100%;
            height: 400px;

            &__wrapper {
                width: 100%;
                height: 400px;
                border-radius: 4px;
                overflow: hidden;
            }
        }
    }
</style>
